const unreadAnnouncements = state => state.unreadAnnouncements;

export {
  unreadAnnouncements,
}